import React from 'react';
import { cn } from '../../lib/utils';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Plus } from 'lucide-react';
import { useBanners } from './hooks/useBanners';
import { BannersTable, BannerDialog } from './components';
import { BannersPageProps } from './types';

export default function BannersPage({ isDark }: BannersPageProps) {
  const {
    banners,
    isLoading,
    isCreateDialogOpen,
    isEditDialogOpen,
    formData,
    isSubmitting,
    errors,
    clearFieldError,
    setIsCreateDialogOpen,
    setIsEditDialogOpen,
    setFormData,
    openCreateDialog,
    handleCreate,
    handleEdit,
    handleUpdate,
    handleDelete,
    handleToggleActive,
  } = useBanners();

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1
            className={cn(
              'text-2xl lg:text-3xl font-bold tracking-tight',
              isDark ? 'text-white' : 'text-[#111111]',
            )}
          >
            Баннеры
          </h1>
          <p className={cn('text-sm mt-1', isDark ? 'text-slate-400' : 'text-slate-500')}>
            Промо-блок на главном экране приложения. Одновременно показывается один — с
            наибольшим приоритетом среди подходящих
          </p>
        </div>
        <Button onClick={openCreateDialog} className="bg-[#C9A227] hover:bg-[#C9A227]/90">
          <Plus className="w-4 h-4 mr-2" />
          Создать баннер
        </Button>
      </div>

      <Card
        className={cn(
          'rounded-2xl border-0 overflow-hidden transition-all duration-300',
          isDark
            ? 'bg-[#1A1A22] shadow-lg shadow-black/10'
            : 'bg-white shadow-lg shadow-slate-200/50',
        )}
      >
        <BannersTable
          isDark={isDark}
          banners={banners}
          isLoading={isLoading}
          onEdit={handleEdit}
          onDelete={handleDelete}
          onToggleActive={handleToggleActive}
        />
      </Card>

      <BannerDialog
        isDark={isDark}
        isOpen={isCreateDialogOpen}
        onOpenChange={setIsCreateDialogOpen}
        formData={formData}
        onFormDataChange={setFormData}
        onSubmit={handleCreate}
        isSubmitting={isSubmitting}
        errors={errors}
        onClearFieldError={clearFieldError}
        title="Создать баннер"
        description="Появится на главном экране приложения"
        submitLabel="Создать"
      />

      <BannerDialog
        isDark={isDark}
        isOpen={isEditDialogOpen}
        onOpenChange={setIsEditDialogOpen}
        formData={formData}
        onFormDataChange={setFormData}
        onSubmit={handleUpdate}
        isSubmitting={isSubmitting}
        errors={errors}
        onClearFieldError={clearFieldError}
        title="Редактировать баннер"
        description="Изменения увидят пользователи при следующем открытии главного экрана"
        submitLabel="Сохранить"
      />
    </div>
  );
}
